import React, { useEffect, useState } from "react";
import Menu from "../../components/Menu";
import { useParams, useNavigate } from "react-router-dom";
import api from '../../api'
import Swal from 'sweetalert2'
import FooterEdit from "../../components/FooterEdit";
import LoadingBlock from "../../components/LoadingBlock";
//import ModalYesNo from "../../components/ModalYesNo";

export default function ProceduresEdit() {
  let { id } = useParams();
  const navigate = useNavigate()

  const [loading, setLoading] = useState(false)
  const [sectors, setSectors] = useState([]);

  const [error, setError] = useState({})

  const [name, setName] = useState('');
  const [ownCode, setOwnCode] = useState('');
  const [sectorId, setSectorId] = useState('');
  const [nameCbhpm, setNameCbhpm] = useState('');
  const [cbhpmCode, setCbhpmCode] = useState('');
  const [tussCode, setTussCode] = useState('');
  const [duration, setDuration] = useState('');
  const [dayLimit, setDayLimit] = useState('');
  const [isLab, setIsLab] = useState(false);
  const [secondary, setSecondary] = useState('');
  const [pqa, setPqa] = useState('');
  const [procAnesthesia, setProcAnesthesia] = useState('');
  const [mnemonico, setMnemonico] = useState('');

  useEffect(() => {
    async function getSectors() {
      await api.get('/api/sectors/list').then((response) => {
        setSectors(response.data);
      })
        .catch((error) => {
          console.error(error);
        })
    }

    getSectors();
  }, [])

  useEffect(() => {
    async function getProcedure() {
      setLoading(true);

      await api.get('/api/procedures/' + id).then((response) => {
        const procedure = response.data.data

        setName(procedure.name || '');
        setOwnCode(procedure.own_code || '');
        setSectorId(procedure.sector_id || '');
        setNameCbhpm(procedure.name_cbhpm || '');
        setCbhpmCode(procedure.cbhpm_code || '');
        setTussCode(procedure.tuss_code || '');
        setDuration(procedure.duration || '');
        setDayLimit(procedure.day_limit || '');
        setIsLab(procedure.is_lab);
        setSecondary(procedure.secondary);
        setPqa(procedure.pqa);
        setProcAnesthesia(procedure.proc_anesthesia);
        setMnemonico(procedure.mnemonico || '');
      }).catch((error) => {
        console.error('Error fetching procedure:', error);
      }).finally(() => {
        setLoading(false);
      })
    }

    getProcedure()
  }, [id])

  // const onDelete = () => {
  //     setShowModal(false)
  //     setLoading(true)
  //     api.delete("/api/agreements/" + id).then((response) => {
  //         Swal.fire({
  //             title: "Convênio excluído com sucesso",
  //             icon: 'success',
  //             confirmButtonColor: '#3c8dbc',
  //         })
  //         setTimeout(() => {
  //             Swal.close()
  //             setTimeout(() => {
  //                 navigate('/agreements')
  //             }, 750);
  //         }, 1500);
  //     }).catch((error) => {
  //         console.error(error)
  //         Swal.fire({
  //             title: "Convênio não excluído",
  //             text: error.message,
  //             icon: 'error',
  //             confirmButtonColor: '#3c8dbc',

  //         })
  //     }).finally(() => {
  //         setLoading(false)
  //     })

  // }

  // Route::get('/procedures/search/{var}', 'ProcedureController@searchProcedure')->name('procedures.search');
  //   Route::get('/procedures/{id}', 'ProcedureController@show')->name('procedures.show');
  //   Route::put('/procedures', 'ProcedureController@update')->name('procedures.update');

  const onSubmit = async (ev) => {
    ev.preventDefault()

    var errors = {
      name: name.replaceAll(' ', '') === '' ? true : false,
    }
    setError(errors)
    var validations = true

    for (const key in errors) {
      if (errors.hasOwnProperty(key) && errors[key] === true) {
        validations = false;
      }

      if (validations) {
        setLoading(true)

        const payload = {
          id: Number(id),
          name,
          own_code: ownCode,
          sector_id: sectorId,
          name_cbhpm: nameCbhpm,
          cbhpm_code: cbhpmCode,
          tuss_code: tussCode,
          duration,
          day_limit: dayLimit,
          is_lab: isLab,
          secondary,
          pqa,
          proc_anesthesia: procAnesthesia,
          mnemonico,
        };

        await api.put("/api/procedures", payload).then((response) => {
          Swal.fire({
            title: "Procedimento atualizado com sucesso",
            icon: 'success',
            confirmButtonColor: '#3c8dbc',
          })

          navigate('/procedures', { replace: true });
        }).catch((error) => {
          console.error(error)
          Swal.fire({
            title: "Procedimento não atualizado",
            text: error.message,
            icon: 'error',
            confirmButtonColor: '#3c8dbc',

          })
        }).finally(() => {
          setLoading(false)
        })
      }
    }
  }

  const screenTela =
    <>
      {loading && <LoadingBlock />}
      {/* <ModalYesNo show={showModal} setShow={setShowModal} affirnName={"Deletar"} negName={"Voltar"} afirmativeFunc={onDelete} message={"Ao excluir um registro não será possivel recuperar"} title={"Tem certeza?"} imgSVG={Clear} /> */}
      <form onSubmit={onSubmit}>
        <div className='screenContainer edit-mode'>
          <h1>Procedimento</h1>

          <div className="d-flex flex-column gap-3">
            <div className="row">
              <div className="col-6">
                <label className="form-label-input">Nome*</label>
                <input className="form-control" value={name} type="text" name="name" placeholder="Nome" onChange={value => setName(value.target.value.toUpperCase())} />
                {error.name && <span className="error" >Campo Inválido</span>}
              </div>

              <div className="col-6">
                <label className="form-label-input">Nome CBHPM*</label>
                <input className="form-control" value={nameCbhpm} type="text" name="name" placeholder="Nome CBHPM" onChange={value => setNameCbhpm(value.target.value.toUpperCase())} />
              </div>
            </div>

            <div className="row">
              <div className="col-4">
                <label className="form-label-input">Código CBHPM*</label>
                <input className="form-control" value={cbhpmCode} type="text" name="name" placeholder="Código CBHPM" onChange={value => setCbhpmCode(value.target.value.toUpperCase())} />
              </div>

              <div className="col-4">
                <label className="form-label-input">Código Próprio*</label>
                <input className="form-control" value={ownCode} type="text" name="name" placeholder="Código Próprio" onChange={value => setOwnCode(value.target.value.toUpperCase())} />
              </div>

              <div className="col-4">
                <label className="form-label-input">Código Tuss*</label>
                <input className="form-control" value={tussCode} type="text" name="name" placeholder="Código Tuss" onChange={value => setTussCode(value.target.value.toUpperCase())} />
              </div>
            </div>

            <div className="row">
              <div className="col-4">
                <label className="form-label-input">Setor*</label>
                <select name="sector" value={sectorId} className="form-select" onChange={value => setSectorId(value.target.value)}>
                  <option value="" disabled>Selecione um Setor</option>
                  {sectors.map((sector) => (
                    <option key={sector.id} value={sector.id}>{sector.name}</option>
                  ))}
                </select>
              </div>

              <div className="col-4">
                <label className="form-label-input">Duração*</label>
                <input className="form-control" value={duration} type="time" name="duration" placeholder="00:00" onChange={value => setDuration(value.target.value)} />
              </div>

              <div className="col-4">
                <label className="form-label-input">Limite Diário*</label>
                <input className="form-control" value={dayLimit} type="number" name="dayLimit" placeholder="0" onChange={value => setDayLimit(value.target.value)} />
              </div>
            </div>

            <div className="row">
              <div className="col-4">
                <label className="form-label-input">Mnemônico*</label>
                <input className="form-control" value={mnemonico} type="text" name="mnemonico" placeholder="Mnemônico" onChange={value => setMnemonico(value.target.value.toUpperCase())} />
              </div>

              <div className="col-2 d-flex align-items-end">
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="isLab"
                    name="isLab"
                    checked={isLab}
                    onChange={value => setIsLab(value.target.checked)}
                  />
                  <label className="form-check-label" htmlFor="isLab">
                    Laboratório
                  </label>
                </div>
              </div>

              <div className="col-2 d-flex align-items-end">
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="secondary"
                    name="secondary"
                    checked={secondary}
                    onChange={value => setSecondary(value.target.checked)}
                  />
                  <label className="form-check-label" htmlFor="secondary">
                    Secundário
                  </label>
                </div>
              </div>

              <div className="col-2 d-flex align-items-end">
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="pqa"
                    name="pqa"
                    checked={pqa}
                    onChange={value => setPqa(value.target.checked)}
                  />
                  <label className="form-check-label" htmlFor="pqa">
                    PQA
                  </label>
                </div>
              </div>

              <div className="col-2 d-flex align-items-end">
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="procAnesthesia"
                    name="procAnesthesia"
                    checked={procAnesthesia}
                    onChange={value => setProcAnesthesia(value.target.checked)}
                  />
                  <label className="form-check-label" htmlFor="procAnesthesia">
                    Anestesia
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <FooterEdit navigateRoute={"/procedures"} onClickDel={null} />
      </form>
    </>

  return (
    <Menu screen={screenTela} />
  )
}